/* eslint-disable react/prop-types */
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import React, { useEffect, useState } from 'react';
// api
import BaseApi from '../../api/BaseApi';
// components
import SmallLoading from '../../element/SmallLoading';
// mui
import { Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const AdminLogin = ({ captchaKey }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [errors, setErrors] = useState({ username: '', password: '' });
  const [loginData, setLoginData] = useState({ username: '', password: '' });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setLoginData(prev => ({
      ...prev,
      [name]: value,
    }));

    setErrors(prev => ({
      ...prev,
      [name]: '',
    }));
  };

  const getData = async e => {
    e.preventDefault();

    try {
      const newErrors = {};

      if (loginData.username === '') {
        newErrors.username = 'Username is required';
        window.scrollTo(0, 0);
      }
      if (loginData.password === '') {
        newErrors.password = 'Password is required';
        window.scrollTo(0, 0);
      }
      if (!isCaptchaVerified) {
        newErrors.captcha = 'Please verify captcha';
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        if (isCaptchaVerified) {
          setLoading(true);

          const response = await axios.post(
            BaseApi + '/admin/new/login',
            loginData,
          );

          const status = response.data.status;
          const adminID = response.data.response.adminid;
          const tokenFetch = response.data.response.token;
          const fnameFetch = response.data.response.first_name;
          const usertypeFetch = response.data.response.user_type;

          setLoading(false);

          if (status === 200 && tokenFetch !== '') {
            Cookies.set('adminID', adminID);
            Cookies.set('token', tokenFetch);
            Cookies.set('adminName', fnameFetch);
            Cookies.set('adminuser_type', usertypeFetch);

            axios.defaults.headers.common['Authorization'] = `Bearer ${tokenFetch}`;

            navigate('/admin/admins/dashboard');

            const Toast = Swal.mixin({
              timer: 3000,
              toast: true,
              position: 'top-end',
              timerProgressBar: true,
              showConfirmButton: false,
              didOpen: toast => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: 'success',
              title: 'Welcome ' + fnameFetch,
            });
          } else if (response.data.status === 500) {
            const Toast = Swal.mixin({
              timer: 3000,
              toast: true,
              position: 'top-end',
              timerProgressBar: true,
              showConfirmButton: false,
              didOpen: toast => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: 'error',
              title: response.data.message,
            });
          } else {
            console.error('Nothing works');
          }
        }
      }
    } catch (error) {
      setLoading(false);

      Swal.fire({
        icon: 'error',
        confirmButtonText: 'Close',
        title: 'Could not log you in!',
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='container centerContainer'>
                <div className='card rounded loginCardStyles'>
                  <div className='row'>
                    <div className='text-center mt-2'>
                      <img src='/Images/Logo.png' alt='logo' width='50px' />
                      <div className='card-title h3 pt-5'>ADMINISTRATION LOGIN</div>
                      <div className='card-body'>
                        <form onSubmit={getData} className='text-center border border-light'>
                          <div className='mb-4'>
                            <input
                              type='text'
                              name='username'
                              placeholder='Username'
                              onChange={handleChange}
                              id='defaultLoginFormEmail'
                              value={loginData.username}
                              className={`form-control ${errors.username && 'input-error'}`}
                            />
                            {
                              errors.username && (
                                <div className='text-danger adminValidation'>
                                  {errors.username}
                                </div>
                              )
                            }
                          </div>
                          <div className='mb-4 passwordBox'>
                            <input
                              name='password'
                              placeholder='Password'
                              onChange={handleChange}
                              value={loginData.password}
                              id='defaultLoginFormPassword'
                              type={showPassword ? 'text' : 'password'}
                              className={`form-control ${errors.password && 'input-error'}`}
                            />
                            <div className='passwordVisibilityAdmin'>
                              <p
                                className='btn-primary'
                                type='button'
                                onClick={togglePasswordVisibility}
                              >
                                {
                                  showPassword ? (
                                    <Tooltip title='Hide Password'>
                                      <VisibilityOffIcon />
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title='View Password'>
                                      <VisibilityIcon />
                                    </Tooltip>
                                  )
                                }
                              </p>
                            </div>
                            {
                              errors.password && (
                                <div className='text-danger adminValidation'>
                                  {errors.password}
                                </div>
                              )
                            }
                          </div>
                          <div className='reCaptchaLogin'>
                            {
                              captchaKey
                                ? <ReCAPTCHA sitekey={captchaKey} onChange={value => setIsCaptchaVerified(value)} />
                                : <SmallLoading />
                            }
                            {
                              errors.captcha && (
                                <div className='text-danger adminValidation'>
                                  {errors.captcha}
                                </div>
                              )
                            }
                          </div>
                          <button type='submit' onClick={getData} className='btn button1 my-2 '>Login</button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
      }
    </>
  );
};

export default AdminLogin;
